import React, { useCallback, useEffect, useState } from 'react';
import './SessionsPage.css';
import { useSelector } from 'react-redux';
import {
  getLoading,
  setSessionloading,
  stopSessionAsync,
  getRecordingAsync,
  getCurrentRecordingUrl,
  setCurrentRecordingUrl,
  getSessionsAsync,
  getSessions,
  getCurrentRecordingsParts,
} from '../../../features/redux/adminSlice';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import SideSlider from '../../ui/SideSlider/SideSlider';
import { useForm } from 'react-forms-handler';
import Confirm from '../../ui/Confirm/Confirm';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function SessionsPage() {
  const [recordingsOpen, setRecordingssOpen] = useState(null);
  const sessions = useSelector(getSessions);
  const [currentSessonId, setCurrentSessonId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  // const [active, setActive] = useState(true);
  const isLoading = useSelector(getLoading);
  const [openForm, setOpenForm] = useState(false);
  const dispatch = useDispatch();
  const currentRecordingUrl = useSelector(getCurrentRecordingUrl);
  const currentRecordingsParts = useSelector(getCurrentRecordingsParts);
  const [fromDate, setFromDate] = useState(
    moment().subtract(7, 'days').toDate(),
  );
  const [toDate, setToDate] = useState(new Date());
  const { form, value, serchField, active } = useForm({
    active: true,
    serchField: [''],
  });

  useEffect(() => {
    dispatchSearch(dispatch, form, fromDate, toDate);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (currentRecordingUrl) {
        console.log('sending message');
        document.getElementById('recording-iframe').contentWindow.postMessage(
          {
            url: currentRecordingUrl,
          },
          '*',
        );
      }
    }, 3000);
  }, [currentRecordingUrl]);

  return (
    <div className='sessions-dashboard-content'>
      <div className='dashboard-header'>
        <input
          style={{ width: '20%' }}
          type='text'
          className='form-control'
          {...serchField.inputProps}
          placeholder='Search'
          onChange={(e) => {
            serchField.value = e.target.value;
            dispatchSearch(dispatch, form, fromDate, toDate);
          }}
        />
        <div className='input-group ml-3' style={{ width: '20%' }}>
          <select
            className='custom-select'
            {...active.inputProps}
            onChange={(e) => {
              active.value = e.target.value;
              dispatchSearch(dispatch, form, fromDate, toDate);
            }}
          >
            <option value={true}>Active</option>
            <option value={false}>inactive</option>
          </select>
        </div>
        <div className=' ml-3'>
          <DatePicker
            selected={fromDate}
            onChange={(date) => {
              setFromDate(date);
              dispatchSearch(dispatch, form, date, toDate);
            }}
            showTimeSelect
            className='form-control'
            placeholderText='From'
            dateFormat='Pp'
          />
        </div>
        <div className=' ml-3'>
          <DatePicker
            selected={toDate}
            onChange={(date) => {
              setToDate(date);
              dispatchSearch(dispatch, form, fromDate, date);
            }}
            showTimeSelect
            className='form-control'
            placeholderText='To'
            dateFormat='Pp'
          />
        </div>
      </div>
      <table className='table'>
        <thead className='thead-light'>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Session Id</th>
            <th scope='col'>Active</th>
            {!isActive(active.value) && <th scope='col'>Recordings</th>}
            <th scope='col'>User</th>
            <th scope='col'>Credetinal username</th>
            <th scope='col'>Application Name</th>
            <th scope='col'>Created AT</th>
            <th scope='col'>Ended At</th>
            <th scope='col'>
              {isActive(active.value) ? 'Actions' : 'Duration'}
            </th>
          </tr>
        </thead>
        <tbody>
          {sessions.map((session, index) => {
            return (
              <tr key={'session-' + index}>
                <th scope='row'>{index + 1}</th>
                <td>{session.id}</td>
                <td>{!session.end_date ? 'active' : 'inactive'}</td>
                {!isActive(active.value) && (
                  <td>
                    {session.has_record && (
                      <div className='dropdown'>
                        <a className='dropdown-item' href='#'>
                          {/* {r.name.split('/').pop()}  */}
                          <i
                            style={{ marginLeft: '4px', cursor: 'pointer' }}
                            className={`text-success fa-solid fa-play`}
                            onClick={() => {
                              dispatch(
                                getRecordingAsync({
                                  recordingName: session.id,
                                }),
                              );
                              setCurrentSessonId(session.id);
                              setOpenForm(true);
                            }}
                          ></i>
                        </a>
                      </div>
                    )}
                  </td>
                )}
                <td>{session.user.name}</td>
                <td>{session.credential.user_name}</td>
                <td>{session.application.name}</td>
                <td>
                  {moment(session.created_at).format('MMM Do YY, h:mm:ss a')}
                </td>
                <td>
                  {session.end_date
                    ? moment(session.end_date).format('MMM Do YY, h:mm:ss a')
                    : '---'}
                </td>
                {isActive(active.value) && (
                  <td>
                    {isActive(active.value) && (
                      <i
                        style={{ marginLeft: '4px', cursor: 'pointer' }}
                        className={`text-danger fa-solid fa-${isLoading.sessions != session.id ? 'stop' : 'circle-notch fa-spin'}`}
                        onClick={() => {
                          Confirm.confirm(
                            'Are you sure you want to stop application. User might use it right now',
                          )
                            .then(() => {
                              dispatch(setSessionloading(session.id));
                              dispatch(
                                stopSessionAsync({ session_id: session.id }),
                              );
                            })
                            .catch((e) => {
                              console.log(e);
                            });
                        }}
                      ></i>
                    )}
                  </td>
                )}

                {!isActive(active.value) && (
                  <td>
                    {moment(session.end_date)
                      .diff(moment(session.created_at), 'minutes', true)
                      .toFixed(2)}{' '}
                    minutes
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      <SideSlider
        open={openForm}
        style={{
          width: '85%',
          right: openForm ? '0' : '-85%',
          animationName: openForm
            ? 'slide-in-recordings'
            : 'slide-out-recordings',
        }}
      >
        <i
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            cursor: 'pointer',
          }}
          className={`text-primary fa-solid fa-rectangle-xmark`}
          onClick={() => {
            setOpenForm(false);
            setCurrentSessonId(null);
            setCurrentPage(1);
            dispatch(setCurrentRecordingUrl(null));
          }}
        ></i>
        {currentRecordingUrl && (
          <iframe
            id='recording-iframe'
            style={{ width: '100%', height: '100%' }}
            src={`https://applications.ring.do/tests/vnc_playback.html`}
          ></iframe>
        )}
      </SideSlider>
    </div>
  );
}

export default SessionsPage;

function dispatchSearch(dispatch, form, from, to) {
  dispatch(
    getSessionsAsync({
      params: {
        active: form.value.active,
        search: form.value.serchField,
        from: new Date(from).toISOString(),
        to: new Date(to).toISOString(),
      },
    }),
  );
}

function isActive(value) {
  return value === true || value === 'true';
}
